const resolveObjPath = (obj, splitPath) =>
    splitPath && splitPath.reduce((acc, curr) => (acc ? acc[curr] : null), obj);

export const resolveObjPathString = (obj, path) =>
    path.split(".").reduce((acc, curr) => (acc ? acc[curr] : null), obj);

export default resolveObjPath;
